import { Injectable, Inject } from '@angular/core';


export class PolicyCoverageScheduleDO {
	public id: Number = null;
	public policyYear: Number = 0;
	public sumInsured: Number = 0.0;
	public baseAnnualPremium: Number = 0;
	public premiumRate: Number = 0;
	public productTypeCd: any = null;

}
